import { createSignal } from '@verclam/pulsar';

/** `null` closes the panel; a template id opens it, editing that template's name and description. */
const documentTemplateEditSidebarSignal = createSignal<number | null>(null);

export const openDocumentTemplateEditSidebar = (templateId: number): void => {
	documentTemplateEditSidebarSignal.value = templateId;
};

export const closeDocumentTemplateEditSidebar = (): void => {
	documentTemplateEditSidebarSignal.value = null;
};

export default documentTemplateEditSidebarSignal;
